import { type Maybe } from '@adornis/base/utilTypes.js';
import { getExposedActionsOfElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { Workshop } from '@adornis/buchungsheld-db/entities/workshop.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { DialogOptions } from '@adornis/dialog/x-plain-dialog.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { until } from 'lit/directives/until.js';
import '../pages/admin/einrichtung/workshops/bh-page--admin-einrichtung-workshops-modify.js';

@customElement('bh-prompt-workshop-add')
export class BHPromptWorkshopAdd extends TrDialog<Maybe<Workshop>> {
  @property({ attribute: false }) institutionID = new RXController<string | null>(this, null);

  @state() private formRef = createRef();

  static add(institutionID: string): Promise<Maybe<Workshop>> {
    return this.showPopup<Maybe<Workshop>>({
      props: { institutionID },
    });
  }

  override async cancel(returnVal?: any): Promise<void> {
    await this.close(null);
  }

  static override get element_name() {
    return 'bh-prompt-workshop-add';
  }

  override render() {
    if (this.institutionID.isLoading || !this.institutionID.value) {
      return html`<x-loading-state></x-loading-state>`;
    }

    // TODO: do that without timeout
    const actions = new Promise(resolve =>
      setTimeout(() => {
        const actions = this.formRef.value ? getExposedActionsOfElement(this.formRef.value, false) : {};
        const actionHtml = Object.values(actions).map(
          action =>
            html`<x-button
              icon=${action.icon}
              @click=${() => {
                action.callback();
              }}
              >${action.text}</x-button
            >`,
        );
        resolve(actionHtml);
      }, 2000),
    );

    return html`
      <x-flex space="md" ${css({ maxHeight: 'calc(min(90vh, 800px) - 50px)', padding: '0 20px' })}>
        <x-h2>${this._translation.translate('workshop', 'add')}</x-h2>

        <bh-page-admin-einrichtung-workshops-modify
          ${ref(this.formRef)}
          mode="add"
          institution-id="${this.institutionID.value}"
          @saved="${(e: CustomEvent) => this.close(e.detail.workshop)}"
        ></bh-page-admin-einrichtung-workshops-modify>

        <x-flex horizontal> ${until(actions)} </x-flex>
      </x-flex>
    `;
  }

  override getInnerWrapper(options: Required<DialogOptions>) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty('background', this.colors.white);
    wrapperElem.style.setProperty('border-radius', this.sizes.borderRadius);
    wrapperElem.style.setProperty('width', `min(90%, 1200px)`);
    wrapperElem.style.setProperty('height', `min(90vh, 800px)`);
    wrapperElem.style.setProperty('padding', this.spacing.lg);
    wrapperElem.style.setProperty('overflow-y', 'auto');
    return wrapperElem;
  }
}
